import { Box, Typography } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const AccessDisabled = () => {
  const { t } = useTranslation("error");
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !(initialized && keycloak?.authenticated) ||
      !keycloak?.hasRealmRole("Access Disabled")
    ) {
      navigate("/auth/login", {
        replace: true,
        state: { from: window.location.pathname },
      });
    }
  }, []);

  return (
    <Box
      display="flex"
      minWidth="100vw"
      minHeight="100vh"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <Typography variant="h3" color="#1769ff" marginBottom={2}>
        {t("access-disabled-title")}
      </Typography>
      <Typography
        variant="body2"
        fontSize="1.5rem"
        color="#4180f5"
        textAlign={"center"}
      >
        {t("access-disabled-message")}
      </Typography>
    </Box>
  );
};
